<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t("Filiallar") }}</h2>
        <div class="header-actions">
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="filter" type="search" :placeholder="$t('Qidiruv...')" class="modern-search">
          </div>
          <button class="refresh-btn" @click="Refresh()" :title="$t('Yangilash')">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>
          <button class="add-btn" @click="Href('/malumot/sklad/create')" v-if="rule.change == true">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}
          </button>
          <top></top>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width:80px">ID</th>
                <th>{{ $t("Nomi") }}</th>
                <th>{{ $t("Telefon") }}</th>
                <th>{{ $t("Chek izohi") }}</th>
                <th>{{ $t("Tugash vaqti") }}</th>
                <th style="width:120px;text-align:center">{{ $t("Amallar") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paginatedItems" :key="item.id" @dblclick="Update(item)">
                <td><span class="id-badge">#{{ item.id }}</span></td>
                <td class="font-bold">{{ item.name }}</td>
                <td class="text-secondary">{{ item.phone_number }}</td>
                <td class="text-secondary">{{ item.check_word }}</td>
                <td class="text-secondary">{{ $formatDate(item.datetime2) }}</td>
                <td>
                  <div class="actions">
                    <button class="icon-btn edit" @click="OpenRename(item)" v-if="rule.change == true" title="Filial nomini o'zgartirish" aria-label="Filial nomini o'zgartirish">
                      <b-icon icon="type"></b-icon>
                    </button>
                    <button class="icon-btn edit" @click="Update(item)">
                      <b-icon icon="pencil"></b-icon>
                    </button>
                    <button class="icon-btn del" @click="ConfirmTrash(item.id)" v-if="rule.change == true">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="filteredItems.length === 0">
                <td colspan="6" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-footer">
          <div class="info">
            {{ totalRows }} {{ $t('ta listdan') }}
            {{ Math.min(currentPage * $store.state.countindex, totalRows) }} {{ $t('tasi') }}
          </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="$store.state.countindex"
            align="right" size="sm" class="my-0"
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-modal id="modal-rename-branch" title="Filial nomini o'zgartirish" hide-footer centered :no-close-on-backdrop="renaming" :no-close-on-esc="renaming" :hide-header-close="renaming">
      <form @submit.prevent="RenameBranch">
        <label for="branch-name">Filial nomi</label>
        <input id="branch-name" v-model="renameForm.name" class="form-control" type="text" maxlength="50" required :disabled="renaming" />
        <p v-if="renameError" class="text-danger mt-2" role="alert">{{ renameError }}</p>
        <div class="modal-footer-btns mt-3">
          <button type="button" class="m-btn cancel-btn" :disabled="renaming" @click="$bvModal.hide('modal-rename-branch')">Bekor qilish</button>
          <button type="submit" class="btn btn-success" :disabled="renaming || !renameForm.name.trim()">{{ renaming ? 'Saqlanmoqda...' : 'Saqlash' }}</button>
        </div>
      </form>
    </b-modal>

    <!-- O'CHIRISH MODALI -->
    <b-modal id="modal-delete" hide-footer centered no-stacking no-close-on-backdrop>
      <div class="text-center p-3">
        <div class="warning-icon mb-3">!</div>
        <h3 class="fw-bold mb-2">{{ $t("O'chirishni tasdiqlaysizmi?") }}</h3>
        <p class="text-muted mb-4">{{ $t("Ushbu amalni ortga qaytarib bo'lmaydi.") }}</p>
        <div class="modal-footer-btns">
          <button class="m-btn cancel-btn" @click="$bvModal.hide('modal-delete')">{{ $t("Yo'q") }}</button>
          <button class="m-btn danger-btn" @click="DeleteData">{{ $t("Ha, o'chirilsin") }}</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { print } from "../../../components/mixins/print.js";
import Top from "../../Layout/Top.vue";

export default {
  mixins: [print],
  components: { Top },
  data() {
    return {
      items: [],
      filter: "",
      currentPage: 1,
      renameForm: { id: null, name: '' },
      renaming: false,
      renameError: '',
      itemToDeleteId: null
    };
  },
  computed: {
    filteredItems() {
      if (!this.filter) return this.items;
      const s = this.filter.toLowerCase();
      return this.items.filter(item =>
        (item.name || '').toLowerCase().includes(s) ||
        (item.phone_number || '').toLowerCase().includes(s) ||
        (item.check_word || '').toLowerCase().includes(s) ||
        item.id.toString().includes(s)
      );
    },
    totalRows() {
      return this.filteredItems.length;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.$store.state.countindex;
      return this.filteredItems.slice(start, start + this.$store.state.countindex);
    }
  },
  created() {
    this.Refresh();
  },
  methods: {
    OpenRename(item) {
      if (!this.rule.change) return;
      this.renameForm = { id: item.id, name: item.name };
      this.renameError = '';
      this.$bvModal.show('modal-rename-branch');
    },
    async RenameBranch() {
      if (this.renaming || !this.rule.change || !this.renameForm.name.trim()) return;
      this.renaming = true;
      this.renameError = '';
      try {
        const { data } = await axios.patch(`api/v1/sklads/id/${this.renameForm.id}/name`, { name: this.renameForm.name.trim() });
        const item = this.items.find(branch => branch.id === data.id);
        if (item) item.name = data.name;
        this.$bvModal.hide('modal-rename-branch');
      } catch (error) {
        const response = error.response && error.response.data;
        this.renameError = typeof response === 'string' ? response : (response && response.message) || 'Nomni saqlashda xatolik yuz berdi.';
      } finally {
        this.renaming = false;
      }
    },
    Refresh() {
      axios.get("api/v1/sklads").then(res => {
        this.items = res.data;
      });
    },
    Update(item) {
      if (this.rule.open == true) {
        this.$router.push({ path: '/malumot/sklad/update/' + item.id });
      }
    },
    ConfirmTrash(id) {
      this.itemToDeleteId = id;
      this.$bvModal.show('modal-delete');
    },
    DeleteData() {
      if (!this.itemToDeleteId) return;
      axios.delete(`api/v1/sklads/id/${this.itemToDeleteId}`).then(() => {
        this.$bvModal.hide('modal-delete');
        this.Refresh();
        this.$bvToast.toast(this.$t("O'chirildi"), { variant: 'success', toaster: 'b-toaster-bottom-center' });
      }).catch(() => {
        this.$bvToast.toast(this.$t("Xatolik yuz berdi"), { variant: 'danger', toaster: 'b-toaster-bottom-center' });
      });
    }
  }
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.content-container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}
.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}
.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
  font-size: 14px;
}
.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}
.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}
.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}
.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
}
.font-bold { font-weight: 700; }
.text-secondary { color: #64748b; font-size: 14px; }
.id-badge {
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 8px;
  font-family: monospace;
  font-weight: 700;
  color: #64748b;
}
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}
.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.edit { background: #eff6ff; color: #2563eb; }
.del  { background: #fff1f2; color: #e11d48; }
.empty-row {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
}
.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
}
.info { color: #94a3b8; font-size: 13px; font-weight: 600; }
.warning-icon {
  width: 60px;
  height: 60px;
  background: #fee2e2;
  color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  margin: 0 auto;
}
.modal-footer-btns { display: flex; gap: 10px; }
.m-btn {
  flex: 1;
  padding: 12px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}
.cancel-btn { background: #f1f5f9; color: #64748b; }
.danger-btn { background: #ef4444; color: white; }
</style>
